import { ApiService } from "./api.service";
import { PrimeIcons } from "@primevue/core/api";
import { Core } from "../helpers/core";
// import { terminology } from "../helpers/terminology";
import { getMyGemService } from "@/services";
export default class EmployeeService extends ApiService {
  namespace = "employee";
  relations =
    "?expand=addresses,contacts,contacts.contactItems,files,files.file,files.file.commentsCount,events,links,links.entity,directDeposit,journals.accounts,user";
  DOMAIN = 17;
  name = "Employee";
  template = "defaultTemplate";
  Width = 1100;
  icon = "ThreeUserx";
  search = true;
  contact = null;
  action = "action";
  singular = this.terminology.employee.singular;
  plural = this.terminology.employee.plural;
  vowel = this.terminology.employee.vowel;
  enableSchedular = true;
  listingTabsNavItems = [];
  gemItems = [
    {
      key: "create",
      label: this.t("addAnEntity", { entity: this.singular }),
      icon: "Plus",
    },
    {
      key: "listing",
      label: this.t("allEntity", { entity: this.plural }),
      icon: "Bullets",
    },
    {
      key: "loader",
      label: this.t("emailEntity", { entity: this.plural }),
      icon: "Mail",
    },
    {
      key: "create",
      label: this.t("generateReport"),
      icon: "DocumentExcel",
    },
  ];
  navItems = [
    {
      key: "active",
      label: this.t("viewActiveEntity", { entity: this.plural }),
      services: 18,
      icon: "Enabled",
    },
    {
      key: "inactive",
      label: this.t("viewInactiveEntity", { entity: this.plural }),
      services: 18,
      icon: "Disable",
    },
    {
      key: "listing",
      label: this.t("allEntity", { entity: this.plural }),
      icon: "Bullets",
    },
    {
      key: "bookmark",
      label: this.t("viewMyBookmarks", { entity: this.singular }),
      icon: "Bookmark",
    },
  ];
  columns = [
    {
      header: this.t("displayName"),
      icon: "UserSilhouette",
      field: "display_name",
      sortable: true,
    },
    {
      header: this.t("lastName"),
      icon: "Tag",
      field: "sur_name",
      sortable: true,
    },
    // {
    //   header: "Primary Phone #",
    //   icon: "MobilePhone",
    //   field: "display_name",
    //   template: (data) => {
    //     // if (data) {
    //     //   this.retrieve(
    //     //     data.id + "?expand=addresses,contacts,contacts.contactItems"
    //     //   ).then((res) => {
    //     //     res.contacts.forEach((element) => {
    //     //       element.contactItems.forEach((item) => {
    //     //         if (item.rank == 1) {
    //     //           this.contact = item.value;
    //     //         }
    //     //       });
    //     //     });
    //     //   });
    //     // }
    //     return data.employee_number;
    //   },
    // },
    {
      header: this.t("email"),
      icon: "Mail",
      field: "notification_email",
      sortable: true,
    },
    {
      header: this.t("number"),
      icon: "Shred",
      field: "employee_number",
      sortable: true,
    },
  ];

  gemMenuItems = [
    {
      key: "create",
      label: "Adding an Employee",
      icon: PrimeIcons.LIST,
    },
  ];
  filterItems = [
    {
      name: "Types",
      key: "type",
      serviceId: "2",
      params: { realm: 2 },
      value: "2",
      realm: "2",
      selected: true,
      add: "create",
      edit: "listing",
      item: { key: "id", label: "display_name" },
    },
    {
      name: "Categories",
      serviceId: "3",
      key: "category",
      params: { realm: 1 },
      value: "3",
      realm: "1",
      selected: false,
      add: "create",
      edit: "listing",
      item: { key: "id", label: "display_name" },
    },
    {
      name: "Folders",
      icon: "FolderOpened",
      key: "hierarchy_id",
      serviceId: "-2",
      params: { realm: 1 },
      item: { key: "id", label: "display_name" },
      value: "-2",
      realm: "0",
      selected: false,
      add: "create",
      edit: "listing",
    },
  ];
  getActionMenu(item) {
    let listMenuItems = [
      {
        key: "edit",
        label: "Edit an Employee",
        icon: "edit",
      },
      {
        key: "announce",
        label: "announceThisEntity",
        services: -3,
        icon: "Announcement",
      },
      {
        key: "email",
        label: "emailThisEntity",
        icon: "Mail",
        services: 208,
      },
      {
        key: "bookmark",
        label: "bookmarkThisEntity",
        icon: "Bookmark",
      },
      {
        key: "status",
        label: 1 == item.status ? "inactiveThisEntity" : "activeThisEntity",
        icon: 1 == item.status ? "Disable" : "Enabled",
      },
    ];
    return listMenuItems;
  }
  constructor() {
    super("employees");
  }
  getName(serviceId, id) {
    var service = getMyGemService(serviceId);
    return service.retrieve(id).then((d) => {
      return d;
    });
  }
}
